exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.date-input[data-v-3127590e]{display:grid;grid-gap:10px;grid-template-columns:repeat(3,1fr);width:100%\n}\n.date-input select[data-v-3127590e]{font-size:14px\n}", ""]);

// exports
